module.exports = __webpack_public_path__ + "static/img/joinPic1.88c15e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/joinPic1.png
// module id = ZNR2
// module chunks = 1